import { render } from "./LanguageButton.vue?vue&type=template&id=17ede4ed&scoped=true"
import script from "./LanguageButton.vue?vue&type=script&lang=js"
export * from "./LanguageButton.vue?vue&type=script&lang=js"

import "./LanguageButton.vue?vue&type=style&index=0&id=17ede4ed&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ede4ed"]])

export default __exports__